import * as React from "react";
// Components
import { Checkbox as FluentCheckbox } from "@fluentui/react";
// Styles
import { getCheckboxStyleFunction } from "./Checkbox.styles";
import { checkMarkIconProps } from "../../../icons/icons.styles";
/**
 * Checkbox control that customizes the fabric control to our own purposes
 */ export const Checkbox = (props)=>{
    const checkboxStyleFunction = getCheckboxStyleFunction(props.appTheme, props.styles);
    return /*#__PURE__*/ React.createElement(FluentCheckbox, {
        ...props,
        checkmarkIconProps: checkMarkIconProps,
        styles: checkboxStyleFunction
    });
};
